import { render, staticRenderFns } from "./DashboardGestao.vue?vue&type=template&id=053ee519&scoped=true"
import script from "./DashboardGestao.vue?vue&type=script&lang=js"
export * from "./DashboardGestao.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestao.vue?vue&type=style&index=0&id=053ee519&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ee519",
  null
  
)

export default component.exports